/**
 * Creates the global Redux store for use throughout all frontend JS.
 *
 * Note that exporting this store creates a singleton instance of the store,
 * which would not be recommended for Node backends.
 */

import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

// Reducers.
import alertBanners from 'modules/alert-banners';
import templateVariables from 'modules/template-variables';
import tve from 'modules/tve';

const rootReducer = combineReducers({
  alertBanners,
  templateVariables,
  tve,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      thunk,
    ),
  ),
);

export default store;
